import React, { useEffect, useState } from 'react';
import styles from '../styles/movies.module.css';
import MovieHeader from './Header';
import PageChange from './PageChange';
import PageChangeBottom from './PageChangeBottom';
import PageChangeMobileTop from './PageChangeMobileTop';
import FilmModal from './FilmModal';

function FilmComp({ currentCategory }) {
  const [movieList, setMovieList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Initialize the current page to 1
  const [selectedMovie, setSelectedMovie] = useState(null); // Store the selected movie
  const [isModalOpen, setIsModalOpen] = useState(false); // Control the modal visibility
  const [selectedMovieId, setSelectedMovieId] = useState(null); // Store the selected movie

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'long' });
    const year = date.getFullYear();
    const dayWithSuffix = getDayWithSuffix(day);

    return `${dayWithSuffix} ${month} ${year}`;
  }

  function getDayWithSuffix(day) {
    if (day >= 11 && day <= 13) {
      return `${day}th`;
    }
    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  }

  function getRatingClass(rating) {
    if (rating < 5) {
      return styles['movie-rating-red-bg']; // Apply the red background class
    } else if (rating >= 5 && rating <= 5.9) {
      return styles['movie-rating-orange-bg']; // Apply the yellow background class
    } else if (rating >= 6 && rating < 7) {
      return styles['movie-rating-yellow-bg']; // Apply the yellow background class
    } else {
      return styles['movie-rating-green-bg']; // Apply the green background class
    }
  }

  useEffect(() => {
    // Reset the page number to 1 only when the category changes
    setCurrentPage(1);
  }, [currentCategory]);

  useEffect(() => {
    // Reset the page number to 1
    window.scrollTo(0, 0); // Scroll to the top of the screen
    // Define a map of category names to API endpoints
    

    const apiKey = '?api_key=7c0455acfe171480b7ef1aa0472b2429';
    const pageNo = `&page=${currentPage}`;

    const categoryToEndpoint = {
      popular: `movie/popular${apiKey}${pageNo}`,
      top_rated: `movie/top_rated${apiKey}${pageNo}`,
      now_playing: `movie/now_playing${apiKey}${pageNo}`,
      upcoming: `discover/movie${apiKey}${pageNo}`,
      trending: `trending/movie/week${apiKey}${pageNo}`,
      horror: `discover/movie${apiKey}${pageNo}&with_genres=27&sort_by=popularity.desc`,
      action: `discover/movie${apiKey}${pageNo}&with_genres=28`,
      comedy: `discover/movie${apiKey}${pageNo}&with_genres=35`,
      romance: `discover/movie${apiKey}${pageNo}&with_genres=10749`,
      documentary: `discover/movie${apiKey}${pageNo}&with_genres=99`,
      family: `discover/movie${apiKey}${pageNo}&with_genres=10751`,
      animation: `discover/movie${apiKey}${pageNo}&with_genres=16`,
      adventure: `discover/movie${apiKey}${pageNo}&with_genres=12`,
      crime: `discover/movie${apiKey}${pageNo}&with_genres=80`,
      drama: `discover/movie${apiKey}${pageNo}&with_genres=18`,
      fantasy: `discover/movie${apiKey}${pageNo}&with_genres=14`,
      history: `discover/movie${apiKey}${pageNo}&with_genres=36`,
    };

    // Build the API URL based on the selected category
    const apiUrl = `https://api.themoviedb.org/3/${categoryToEndpoint[currentCategory]}`;

    // Fetch data using the dynamic API URL
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => setMovieList(data.results))
      .catch((error) => {
        console.error('Error fetching movie data:', error);
      });
    // console log the data
    console.log(apiUrl);
  }, [currentPage, currentCategory]);

  return (
    <div className={styles['whole-page']}>
      <div className={styles['title-and-pages']}>
      <div className={styles['fill']}></div>
        <div className={styles['mobile-header-and-page']}>
        <MovieHeader className={styles['title1']} currentCategory={currentCategory} />
        <PageChangeMobileTop className={styles['mobile-top-page']}currentPage={currentPage}  setCurrentPage={setCurrentPage} currentCategory={currentCategory}  />
        </div>
        <div className={styles['fill']}></div>
        <PageChange className={styles['pages2']}  currentPage={currentPage} setCurrentPage={setCurrentPage} currentCategory={currentCategory} />
      </div>
      <div className={styles['movie-grid']}>
        {movieList.map((movie) => (
          <div className={styles['movie-box']} key={movie.id}
          onClick={() => {
              setSelectedMovie(movie); // Set the selected movie
              setIsModalOpen(true); // Open the modal
              setSelectedMovieId(movie.id);
              console.log(selectedMovieId);
            }}
           >
            <div className={styles['movie-overlay']}>
              <img className={styles['movie-poster']} src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`} alt={movie.title} />
              <p className={getRatingClass(movie.vote_average)}>{movie.vote_average.toFixed(1)}</p>
            </div>
            <div className={styles['movie-bottom']}>
              <div className={styles['title-release']}>
                <h2 className={styles['movie-title']}>{movie.title}</h2>
                <p className={styles['movie-release']}>{formatDate(movie.release_date)}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <PageChangeBottom currentPage={currentPage} setCurrentPage={setCurrentPage} currentCategory={currentCategory}  />
      <FilmModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} movie={selectedMovie || {}} />
    </div>
  );
}

export default FilmComp;
